<template>
  <div class="w-full py-20 mx-auto">
      <div className="w-24 h-24 rounded-full mx-auto border-8 border-solid border-[#f3f3f3] border-t-8 border-t-[#798d9b] animate-spin"></div>
  </div>
</template>

<script>
export default {

}
</script>
